import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type ConfirmDialogProps = {
	opened: boolean;
	title: string;
	body: string;
	confirmLabel?: string;
	confirmColor?: string;
	loading?: boolean;
	onCancel: () => void;
	onConfirm?: () => void;
};

export function ConfirmDialog({
	opened,
	title,
	body,
	confirmLabel,
	confirmColor = "red",
	loading = false,
	onCancel,
	onConfirm,
}: ConfirmDialogProps) {
	const { t } = useTranslation();
	const [copy, setCopy] = useState({
		title,
		body,
		hasConfirm: Boolean(onConfirm),
		confirmLabel,
		confirmColor,
	});

	useEffect(() => {
		if (opened) {
			setCopy({
				title,
				body,
				hasConfirm: Boolean(onConfirm),
				confirmLabel,
				confirmColor,
			});
		}
	}, [opened, title, body, onConfirm, confirmLabel, confirmColor]);

	return (
		<Modal
			opened={opened}
			onClose={() => {
				if (!loading) {
					onCancel();
				}
			}}
			title={copy.title}
			centered
			zIndex={450}
		>
			<Stack>
				<Text size="sm">{copy.body}</Text>
				<Group justify="flex-end">
					<Button variant="default" disabled={loading} onClick={onCancel}>
						{copy.hasConfirm ? t("common.cancel") : t("common.ok")}
					</Button>
					{copy.hasConfirm ? (
						<Button
							color={copy.confirmColor}
							loading={loading}
							onClick={onConfirm}
						>
							{copy.confirmLabel ?? t("common.confirmDeleteAction")}
						</Button>
					) : null}
				</Group>
			</Stack>
		</Modal>
	);
}
